import { ISchema } from './db.types';

const DB_NAME = 'MA1';
const STORE_NAME = 'EE1K';

const openDatabase = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const db = (event.target as any).result;
      db.createObjectStore(STORE_NAME, { keyPath: 'key', autoIncrement: true });
    };

    request.onsuccess = (event: Event) => {
      resolve((event.target as any).result);
    };

    request.onerror = () => {
      reject(new Error('Failed to open IndexedDB'));
    };
  });
};

export const saveToIndexedDB = async <K extends keyof ISchema>(
  key: K,
  value: ISchema[K]
): Promise<void> => {
  const db = await openDatabase();
  const transaction = db.transaction(STORE_NAME, 'readwrite');
  const store = transaction.objectStore(STORE_NAME);

  store.put({ key, value });

  transaction.oncomplete = () => {};
};

export const retrieveFromIndexedDB = async <K extends keyof ISchema>(
  key: K
): Promise<ISchema[K] | null> => {
  const db = await openDatabase();
  const transaction = db.transaction(STORE_NAME, 'readonly');
  const store = transaction.objectStore(STORE_NAME);

  const request = store.get(key);

  return new Promise((resolve, reject) => {
    request.onsuccess = (event: Event) => {
      const { result } = event.target as any;
      resolve(result ? result.value : null);
    };

    request.onerror = () => {
      reject(new Error('Error retrieving value from IndexedDB'));
    };
  });
};

export const removeFromIndexedDB = async <K extends keyof ISchema>(
  key: K
): Promise<void> => {
  const db = await openDatabase();
  const transaction = db.transaction(STORE_NAME, 'readwrite');
  const store = transaction.objectStore(STORE_NAME);

  const request = store.delete(key);

  return new Promise((resolve, reject) => {
    request.onsuccess = () => {
      resolve();
    };

    request.onerror = () => {
      reject(new Error('Error removing record from IndexedDB'));
    };
  });
};

export const removeAESKeyDB = () => {
  removeFromIndexedDB('key');
};
